/**
 * [JSON 고정밀] 부품 키트 이름 — 검사기(서버 생성본 포함)가 쓰는 목록이라 three 를 끌어오지 않는다.
 * 실제 모양은 shared/detail/kits.ts 의 KITS(같은 이름 — __tests__/kitLod 가 대조).
 */
export const KIT_NAMES: readonly string[] = ["wheel", "caster", "bumper", "lidar", "beacon", "estop", "hmi", "motor", "actuator", "base_plate", "bolts", "profile", "cable_chain", "upright", "roller", "led_strip", "photo_eye", "guard_panel", "handrail", "joint_cap", "lift_chain"];
